import { render, staticRenderFns } from "./EditAdminPage.vue?vue&type=template&id=7c596340&scoped=true&"
import script from "./EditAdminPage.vue?vue&type=script&lang=js&"
export * from "./EditAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c596340",
  null
  
)

export default component.exports